var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"content-con"},[_c('img',{attrs:{"src":_vm.src,"alt":"404"}}),_c('back-btn-group',{staticClass:"back-btn-group"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }